import { render, staticRenderFns } from "./DatabaseSource.vue?vue&type=template&id=36f0c032"
import script from "./DatabaseSource.vue?vue&type=script&lang=js"
export * from "./DatabaseSource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports